import { Map } from 'immutable'
import _isFinite from 'lodash/isFinite'
import _toNumber from 'lodash/toNumber'
import { formatCheckoutOrderMarketingValue } from './format-checkout-order-marketing-value'

/**
 * Resolve System A marketing value for checkout — prefer API `marketingValue`, helper fallback.
 * @param {import('immutable').Map} selectedPlan - Selected checkout plan
 * @returns {number}
 */
// eslint-disable-next-line import/prefer-default-export
export function resolveCheckoutMarketingValue (selectedPlan) {
  if (!Map.isMap(selectedPlan)) {
    return 0
  }

  const apiValue = _toNumber(selectedPlan.get('marketingValue'))
  if (_isFinite(apiValue) && apiValue > 0) {
    return apiValue
  }

  return formatCheckoutOrderMarketingValue(selectedPlan)
}
